/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('Params', Params);

function Params($stateParams, ParamsValidator, ConfigBookingEngine, $log) {
  var $this = this;
  $this.$stateParams = $stateParams;
  $this.ParamsValidator = ParamsValidator;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.availableLanguages = null;
  $this.minCheckInTime = null;

  function setMinCheckInTime(time) {
    $this.minCheckInTime = time;
  }

  function setAvailableLanguages(languages) {
    $this.availableLanguages = languages;
  }

  function getUserHash() {
    var userHash = $this.$stateParams.userHash;
    if ($this.ParamsValidator.isValidUserHash(userHash)) {
      return userHash;
    }
    return null;
  }

  function getHotelId() {
    var hotelId = $this.$stateParams.hotelId;
    return hotelId;
   // if ($this.ParamsValidator.isValidHotelId(hotelId)) {
   //   return parseInt(hotelId, 10);
   // }
    //return null;
  }

  function getViewType() {
    var viewType = $this.$stateParams.viewType;
    if(!viewType)
      viewType = 'rooms';

    return viewType;
  }

  function getLanguage() {
    var language = $this.$stateParams.language;
    if ($this.ParamsValidator.isValidLanguage(language, $this.availableLanguages)) {
      return language;
    }
    return 'en';
  }

  function getRoomGroupCategoryFilterId() {
    var roomGroupCategoryFilterId = $this.$stateParams.roomGroupCategoryFilterId;
    if ($this.ParamsValidator.isValidCategoryId(roomGroupCategoryFilterId)) {
      return parseInt(roomGroupCategoryFilterId, 10);
    }
    return null;
  }

  function getCategoryId() {
    var categoryId = $this.$stateParams.categoryId;
    if ($this.ParamsValidator.isValidCategoryId(categoryId)) {
      return parseInt(categoryId, 10);
    }
    return null;
  }

  function getRoomGroupId() {
    var roomGroupId = $this.$stateParams.roomGroupId;
    if ($this.ParamsValidator.isValidRoomGroupId(roomGroupId)) {
      return parseInt(roomGroupId, 10);
    }
    return null;
  }

  function getFeaturedRoomGroupId() {
    var featuredRoomGroupId = $this.$stateParams.featuredRoomGroupId;
    if ($this.ParamsValidator.isValidRoomGroupId(featuredRoomGroupId)) {
      return parseInt(featuredRoomGroupId, 10);
    }
    return null;
  }

  function getRateplanId() {
    var rateplanId = $this.$stateParams.rateplanId;
    if ($this.ParamsValidator.isValidRateplanId(rateplanId)) {
      return parseInt(rateplanId, 10);
    }
    return null;
  }

  function getFeaturedRateplanId() {
    var featuredRateplanId = $this.$stateParams.featuredRateplanId;
    if ($this.ParamsValidator.isValidRateplanId(featuredRateplanId)) {
      return parseInt(featuredRateplanId, 10);
    }
    return null;
  }

  function getCheckIn() {
    var checkIn = $this.$stateParams.checkIn;
    if ($this.ParamsValidator.isValidCheckIn(checkIn, $this.minCheckInTime)) {
      return moment(checkIn).format('YYYY-MM-DD');
    } else if ($this.ParamsValidator.isValidCheckIn(checkIn)) {
      return moment(checkIn).add(1, 'day').format('YYYY-MM-DD');
    }
    var now = moment().format('YYYY-MM-DD');
    if ($this.ParamsValidator.isValidCheckIn(now, $this.minCheckInTime)) {
      return moment(now).format('YYYY-MM-DD');
    }
    return moment(now).add(1, 'day').format('YYYY-MM-DD');
  }

  function getCheckOut() {
    var checkIn = getCheckIn();
    var checkOut = $this.$stateParams.checkOut;

    if ($this.ParamsValidator.isValidCheckOut(checkIn, checkOut)) {
      return moment(checkOut).format('YYYY-MM-DD');
    }
    return moment(checkIn).add(1, 'day').format('YYYY-MM-DD');
  }

  function getOccupancy() {
    var occupancy = $this.$stateParams.occupancy;
    if ($this.ParamsValidator.isValidOccupancy(occupancy)) {
      occupancy = angular.fromJson(decodeURIComponent(occupancy));
      return occupancy;
    }
    return [{count: 2, categoryCount: []}];
  }

  function getCart() {
    var cart = $this.$stateParams.cart;
    if ($this.ParamsValidator.isValidCart(cart)) {
      return angular.fromJson(decodeURIComponent(cart));
    }
    return null;
  }

  function getDiscountCode() {
    var code = $this.$stateParams.discountCode;
    if ($this.ParamsValidator.isValidDiscountCode(code)) {
      return code;
    }
    return null;
  }

  function getPaymentToken() {
    var token = $this.$stateParams.token;
    if ($this.ParamsValidator.isValidPaymentToken(token)) {
      return token;
    }
    return null;
  }

  function getAddons(){
    var queryAddons = $this.$stateParams.addons;
    if(!queryAddons){
      return [];
    }
    var addons = angular.fromJson(decodeURIComponent(queryAddons));

    return addons;
  }

  function getConsent() {
    var queryConsent = $this.$stateParams.consent;

    if (!queryConsent || !$this.ParamsValidator.validateBinary7Digits(queryConsent)) {
      return null;
    }

    var keys = [
      'ad_storage',
      'analytics_storage',
      'functionality_storage',
      'personalization_storage',
      'security_storage',
      'ad_user_data',
      'ad_personalization'
    ];

    var consent = decodeURIComponent(queryConsent);

    var result = {};
    var consentString = String(consent);

    for (var i = 0; i < keys.length; i++) {
      result[keys[i]] = consentString[i] === '1' ? 'granted' : 'denied';
    }

    return result;
  }

  return {
    setMinCheckInTime: setMinCheckInTime,
    setAvailableLanguages: setAvailableLanguages,
    getUserHash: getUserHash,
    getHotelId: getHotelId,
    getLanguage: getLanguage,
    getRoomGroupCategoryFilterId: getRoomGroupCategoryFilterId,
    getCategoryId: getCategoryId,
    getRoomGroupId: getRoomGroupId,
    getRateplanId: getRateplanId,
    getFeaturedRoomGroupId: getFeaturedRoomGroupId,
    getFeaturedRateplanId: getFeaturedRateplanId,
    getCheckIn: getCheckIn,
    getCheckOut: getCheckOut,
    getOccupancy: getOccupancy,
    getCart: getCart,
    getDiscountCode: getDiscountCode,
    getPaymentToken: getPaymentToken,
    getViewType: getViewType,
    getAddons: getAddons,
    getConsent: getConsent
  };
}
